import React from 'react'
import { Button } from '@chakra-ui/react'

const ExportReportBtn = ({ ...rest }) => {
  return <Button {...rest}>Export Report</Button>
}

export default ExportReportBtn
